import React from 'react';
import { Icon } from './Icon.js';
export const IconConnectNodes = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7 5H21V12H14.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 19H3V12H9.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 12L12.375 15H11.625L9 12L11.625 9H12.375L15 12Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "3", y: "3", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "17", y: "17", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconConnectNodes.js.map